export interface Plot {
  id: string;
  assetId: string;
  section?: string | null;
  row?: string | null;
  plotNumber?: string | null;
  position?: number | null;
  plotSize: PlotSize;
  dimensions: {
    length: number;
    width: number;
    depth: number;
  };
  isAvailable: boolean;
  status: PlotStatus;
  description?: string | null;
  notes?: string | null;
  images?: string[] | null;
  createdAt: string;
  updatedAt: string;
  asset?: {
    id: string;
    name: string;
    type: string;
  };
  bookings?: Array<{
    id: string;
    funeralCase: {
      id: string;
      caseNumber: string;
      deceasedName: string;
      user: {
        id: string;
        firstName: string;
        lastName: string;
        phone: string;
      };
    };
  }>;
}

export enum PlotSize {
  ADULT = 'ADULT',
  CHILD = 'CHILD'
}

export enum PlotStatus {
  AVAILABLE = 'AVAILABLE',
  OCCUPIED = 'OCCUPIED',
  RESERVED = 'RESERVED',
  MAINTENANCE = 'MAINTENANCE'
}

export interface PlotFormData {
  section?: string;
  row?: string;
  plotNumber?: string;
  plotSize: PlotSize;
  dimensions?: {
    length?: number;
    width?: number;
    depth?: number;
  };
  isAvailable?: boolean;
  status?: PlotStatus;
  description?: string;
  notes?: string;
  images?: string[];
}

export interface BatchCreatePlotsData {
  assetId: string;
  plotSize: PlotSize;
  plots: Array<{
    section: string;
    row: string;
    plotNumber: string;
    position: number;
    description?: string;
  }>;
  customDimensions?: {
    length: number;
    width: number;
    depth: number;
  };
  defaultAvailable?: boolean;
}

export interface PlotSummary {
  totalPlots: number;
  availablePlots: number;
  occupiedPlots: number;
  reservedPlots: number;
  maintenancePlots: number;
  adultPlots: number;
  childPlots: number;
  sections: string[];
  rows: string[];
}